import { type ApiClient } from "@anna-money/anna-web-lib/api";
import { CountryData } from "./countryTypes";

export class CountryClient {
  private readonly _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  async getCountryList(timeout?: number): Promise<string[]> {
    const response = await this._apiClient.get("/api/formations/countries", { timeout });
    return response.getData(CountryData).countries;
  }
}
